import { noCase, camelCase } from 'change-case'
import pluralize from 'pluralize'
import { mapValues } from '../parsing-utils'

import Mechanism from '../../models/mechanism'

import TypeParser from './field-parsers/type'
import { GlobalFieldParser, PlaybookFieldParser, CharacterFieldParser } from './field-parsers/field'
import ChoiceParser from './field-parsers/choice'
import FormulaParser from './field-parsers/formula'
import ProcedureParser from './field-parsers/procedure'
import HookParser from './field-parsers/hook'
const parserClasses = [TypeParser, FormulaParser, ProcedureParser, ChoiceParser, GlobalFieldParser, PlaybookFieldParser, CharacterFieldParser, HookParser]

export default class MechanismParser {
  constructor (rawRules) {
    this.rawRules = rawRules
    this.parsers = parserClasses.reduce((result, Parser) => ({ ...result, [pluralize(camelCase(Parser.name.replace('Parser', '')))]: new Parser(this) }), { })
  }

  parseAll (mechanisms = {}) {
    return Object.entries(mechanisms).map(([name, rawMechanism]) => this.parse(name, rawMechanism))
  }

  parse (name, mechanism) {
    Object.values(this.parsers).forEach(parser => parser.reset())

    Object.entries(this.parsingFunctions())
      .filter(([field]) => Boolean(mechanism[noCase(field)]))
      .forEach(([field, fieldParsingFunction]) => fieldParsingFunction(mechanism[noCase(field)], this))

    return new Mechanism({ name, ...mapValues(this.parsers, parser => parser.data) })
  }

  parsingFunctions () {
    return mapValues(this.parsers, (parser, field) => ((collection, context) => Object.entries(collection).map(([key, value]) => parser.parseDefinition(key, value))))
  }

  addBasicData (mechanism) {
    Object.entries(this.parsers).forEach(([field, subparser]) => {
      mechanism[field] = subparser.saveBefore ? mechanism[field].concat(subparser.presets) : subparser.presets.concat(mechanism[field])
    })
  }
}
